<div class="modal" (click)="clickOuside()">
    <div class="modal-content" (click)="stopPropagation($event)">
        <div class="modal-header">
          <span class="modal-title">Fiches SAM</span>
          <button type="button" class="modal-close" (click)="closeConfirmationModal()">✕</button>
        </div>
        <div class="modal-body">
            <div class="infos-wrapper">
                <div class="info-ligne">
                    <div class="col-name">
                        Nom de la fiche
                    </div>
                    <div class="info-col">
                        {{fichesSam[currentIndex].nomFiche}}
                    </div>
                </div>
                <div class="info-ligne">
                    <div class="col-name">
                        Titre
                    </div>
                    <div class="info-col">
                        {{fichesSam[currentIndex].titreFiche}}
                    </div>
                </div>
                <div class="info-ligne">
                    <div class="col-name">
                        Auteur
                    </div>
                    <div class="info-col">
                        {{fichesSam[currentIndex].auteur}}
                    </div>
                </div>
                <div class="info-ligne">
                    <div class="col-name">
                        Demandeur
                    </div>
                    <div class="info-col">
                        {{fichesSam[currentIndex].demandeur}}
                    </div>
                </div>
                <div class="info-ligne">
                    <div class="col-name">
                        date de validation
                    </div>
                    <div class="info-col">
                        {{fichesSam[currentIndex].dateValidation}}
                    </div>
                </div>
                <div class="info-ligne">
                    <div class="col-name">
                        date d'actualisation
                    </div>
                    <div class="info-col">
                        {{fichesSam[currentIndex].dateActualisation}}
                    </div>
                </div>
                <div class="info-ligne">
                    <div class="col-name">
                        Numéro de version
                    </div>
                    <div class="info-col">
                        {{fichesSam[currentIndex].numVersion}}
                    </div>
                </div>
                <div class="info-ligne">
                    <div class="col-name">
                        Statut
                    </div>
                    <div class="info-col">
                        {{fichesSam[currentIndex].statut}}
                    </div>
                </div>
                <div class="info-ligne">
                    <div class="col-name">
                        Source
                    </div>
                    <div class="info-col">
                        {{fichesSam[currentIndex].source}}
                    </div>
                </div>
                <div class="info-ligne">
                    <div class="col-name">
                        Contact
                    </div>
                    <div class="info-col">
                        {{fichesSam[currentIndex].contact}}
                    </div>
                </div>
                <div class="info-ligne">
                    <div class="col-name">
                        Logo
                    </div>
                    <div class="info-col">
                        <img [src]="'data:image/png;base64,' + fichesSam[currentIndex].logo">
                    </div>
                </div>
                <div class="info-ligne">
                    <div class="col-name">
                        Lien
                    </div>
                    <div class="info-col">
                        <a [href]="fichesSam[currentIndex].pdf" target="_blank">{{fichesSam[currentIndex].pdf}}</a>
                    </div>
                </div>
                <div class="info-ligne">
                    <div class="col-name">
                        Infos LAP Hospitalier
                    </div>
                    <div class="info-col">
                        {{fichesSam[currentIndex].texteLapHospitalier}}
                    </div>
                </div>
                <div class="info-ligne">
                    <div class="col-name">
                        Infos LAP Medecine Ambulatoire
                    </div>
                    <div class="info-col">
                        {{fichesSam[currentIndex].texteLapMedecineAmbulatoire}}
                    </div>
                </div>
                <div class="info-ligne">
                    <div class="col-name">
                        Infos LAD Officine
                    </div>
                    <div class="info-col">
                        {{fichesSam[currentIndex].texteLadOfficine}}
                    </div>
                </div>
                <div class="info-ligne">
                    <div class="col-name">
                        Infos LAD PUI
                    </div>
                    <div class="info-col">
                        {{fichesSam[currentIndex].texteLadPui}}
                    </div>
                </div>
            </div>
            <div class="button-wrapper">
                <frg-button backgroundColor="var(--darkest-primary)" (activated)="previous()" *ngIf="fichesSam.length > 1">Fiche précédente
                </frg-button>
                <label class="sam-read-toggle">
                  <input type="checkbox" [checked]="fichesSam[currentIndex]?.isRead" (change)="onReadStatusChange($event.target.checked)"
                  />  Ne plus afficher (si <strong>Absence de récurrence SAM</strong> dans les préférences cochée)</label>
                <frg-button backgroundColor="var(--darkest-primary)" (activated)="next()" *ngIf="fichesSam.length > 1">Fiche suivante
                </frg-button>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>
